import axios from 'axios';
//samsung
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class PasswordService {
    async changePassword(current, newp) {
        return await axios
            .put(`/user/admin/change_password`, {
                current_password: current,
                new_password: newp,
            })
            .then((res) => res)
            // .catch((err) => {
            //     errCheck(err);
            // });
    }
    // async editInfos(uname) {
    //     return await axios
    //         .put(`/user/admin/update_account_information`, {
    //             name: uname,
    //         })
    //         .then((res) => res)
    //         .catch((err) => {
    //             errCheck(err);
    //         });
    // }
    async editInfos(data) {
        return await axios
            .post(`api/v1/admin/user/admin-profile-update`, data)
            .then((res) => res);
    }
    async resetPassword( password, email, cpassword) {
        return await axios.post(`api/v1/admin/user/change-password`, {
            password: password,
            email: email,
            cpassword: cpassword,
        }).then((res) => res)
    }   
}
